import jaShareText from '@kurotetsu/share/i18n/lang/ja';
import jaUI from '@linktivity/link-ui/lang/ja';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaIndividualText from './lang/ja';

export const DEFAULT_LOCALE = 'ja';
export const LOCALE_LIST = ['ja'];

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  ja: {
    translation: {
      share: jaShareText,
      ...jaUI,
      ...jaShareText,
      ...jaIndividualText,
      common: {
        ...jaShareText.common
      },
      confirm: {
        ...jaShareText.confirm
      },
      error: {
        ...jaShareText.error
      },
      views: {
        ...jaShareText.views,
        ...jaIndividualText.views,
        login: {
          ...jaShareText.views.login,
          ...jaIndividualText.views.login
        },
        agency: {
          ...jaShareText.views.agency,
          ...jaIndividualText.views.agency
        }
      },
      validation: {
        ...jaShareText.validation,
        password: {
          ...jaShareText.validation.password
        },
        passwordReset: {
          ...jaShareText.validation.passwordReset
        }
      }
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources,
  interpolation: { escapeValue: false }
});

export function setLocale(locale: string): string {
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale);
  localStorage.setItem('locale', locale);
  return locale;
}

(() => {
  const defaultLocale = localStorage.getItem('locale') || DEFAULT_LOCALE;
  setLocale(defaultLocale);
})();

export default i18n;
